module.exports = __webpack_public_path__ + "img/risk-shipment.bcf780f1.png";